import { format } from 'date-fns/format';
import { isValid, parse } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

import { convertJavaToDateFnsDateFormat as toDateFnsFormat } from 'cadenza/utils/date-time/java-to-date-fns-format';
import { getCurrentLocale } from 'cadenza/utils/i18n/i18n';

export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export function formatDateWithJavaFormat (date: Date, javaFormat: string) {
  return format(date, toDateFnsFormat(javaFormat), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
}

export function parseDateWithJavaFormat (dateString: string, javaFormat: string) {
  return parse(dateString, toDateFnsFormat(javaFormat), new Date(), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
}

export function parseAndValidateDateWithJavaFormat (dateString: string, javaFormat: string) {
  const parsedDate = parse(dateString, toDateFnsFormat(javaFormat), new Date(), { useAdditionalDayOfYearTokens: true, locale: getLocale() });
  return isValid(parsedDate) ? parsedDate : null;
}

function getLocale () {
  return getCurrentLocale().startsWith('en') ? enUS : de;
}
